import type { ComponentProps, ReactNode } from 'react';

import { useFieldWiring } from '../hooks/use-field-wiring';
import { cn } from '../lib/utils';
import { Field, FieldLabel, type FieldOverrides, FieldSlot } from './field';
import { Input } from './input';

type Props = ComponentProps<typeof Input> & {
    label: string;
    description?: string;
    error?: boolean | ReactNode;
    fieldProps?: FieldOverrides;
    fieldClassName?: string;
};

function InputField({
    label,
    description,
    error,
    id,
    fieldProps,
    fieldClassName,
    ...inputProps
}: Props) {
    const wiring = useFieldWiring({ id, description, error });
    const { className: fieldPropsClassName, ...restFieldProps } = fieldProps ?? {};

    return (
        <Field
            data-disabled={inputProps.disabled}
            data-invalid={wiring.dataInvalid}
            className={cn(fieldPropsClassName, fieldClassName)}
            {...restFieldProps}
        >
            <FieldLabel htmlFor={wiring.controlId}>{label}</FieldLabel>
            <Input {...inputProps} {...wiring.controlProps} />
            <FieldSlot
                description={description}
                descriptionId={wiring.descriptionId}
                errorMessage={wiring.errorMessage}
                errorId={wiring.errorId}
            />
        </Field>
    );
}

export { InputField };
